module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "notification alert",
    class: [_vm.typeClass, _vm.hasIcon]
  }, [(_vm.closable) ? _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.iconClass) ? _c('div', {
    staticClass: "wrap-icon"
  }, [_c('i', {
    class: ['fa', ("fa-" + _vm.iconClass), _vm.faSpin]
  })]) : _vm._e(), _vm._v(" "), (_vm.title) ? _c('div', {
    staticClass: "title is-5"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notification-content",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-01c8089e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notify/Notify.vue
// module id = 325
// module chunks = 0